import styled from 'styled-components'

export default styled.div`
    align-items: center;
    background: rgba(33, 33, 33, 0.8);
    box-sizing: border-box;
    display: flex;
    padding: 50px 25px;
    position: relative;
    text-align: center;
    width: 100%;

    > div {
        margin: 0 25px;
        text-align: center;
    }

    p {
        text-align: center;
    }

    .item-title {
        margin: 0 0 10px;
        padding: 0;
        text-align: center;
        text-transform: none;
    }

    .item-icon {
        background: no-repeat url('/static/img/app_landing/app_icons.svg');
        background-size: 233px 108px;
        clear: both;
        display: inline-block;
        height: 60px;
        margin: 0 auto 15px;
        width: 60px;

        &.search-icon {
            background-position: 0 -55px;
        }

        &.smiley-icon {
            background-position: -60px -55px;
        }

        &.heart-icon {
            background-position: -120px -55px;
        }

        &.lucky-icon {
            background-position: -180px -55px;
        }

        &.capture-icon {
            background-position: 6px 8px;
        }

        &.easy-icon {
            background-position: -61px 5px;
        }

        &.edit-icon {
            background-position: -120px 5px;
        }

        &.send-icon {
            background-position: -180px 5px;
        }
    }
`
